import { Tag, Typography } from 'antd';
import styled from 'styled-components';

export const StyledText = styled(Typography.Text)`
	cursor: pointer;
`;

export const StyledTag = styled(Tag)`
	margin-top: 0.125rem;
	margin-bottom: 0.125rem;
	padding-left: 0.5rem;
	display: flex;
`;
